import React, { useState } from 'react';
import { Button, Col, Row } from 'shards-react';

const CustomVerticalStepper = ({ steps, stepActive }) => {
    //const [activeStep, setActiveStep] = useState(stepActive);

    // const nextStep = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    // const prevStep = () => setActiveStep((prev) => Math.max(prev - 1, 0));
    // const reset = () => setActiveStep(0);

    return (<>
        {/* <div className="stepper-container">
            <div className="stepper-line" />
            {steps.map((step, index) => (
                <div className="step-row" key={index}>
                    <div className="step-label">{step.label}</div>
                    <div className={`step-circle ${activeStep === index ? "active" : ""}`}>
                        {index + 1}
                    </div>
                </div>
            ))}
        </div> */}
        <Row>
            <Col lg="4">
                <div className="stepper-line" />
                {steps.map((step, index) => (
                    <>
                        <div className='page-header flex-column flex-md-row py-2 d-flex stepperHeight'>
                            {index === stepActive ? <>
                                <div key={step.id + '_' + index} className="d-flex align-items-center ml-3 mt-1 mb-1 p-1 bg-primary"></div>
                            </> : <>
                                <div key={step.id + '_' + index} className="d-flex align-items-center ml-3 mt-1 mb-1 p-1 bg-white"></div>
                            </>}
                            <div key={step.id + '-' + index} className='pt-3 step-row' style={{ marginBottom: '20px' }}>
                                <div className='step-label'
                                    style={{
                                        fontWeight: stepActive === index ? 'bold' : 'normal',
                                        color: stepActive >= index ? '#000' : '#aaa',
                                    }}
                                >
                                    <span className=''>{step.label}</span>
                                </div>
                            </div>

                            <div key={step.id + '=' + index} className='ml-1 mt-2'>
                                {index === stepActive ? <>
                                    <span key={index} className="circle-button float_right step-circle active">{index + 1}</span>
                                </> : 
                                    index < stepActive ? <>
                                    <span className="circle-button float_right step-circle active">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                    </span>
                                    </> : <>
                                    <span className="circle-button float_right step-circle">{index + 1}</span>
                                </>}
                            </div>
                        </div>
                    </>
                ))}
            </Col>
            <Col lg="8">
                {steps.map((step, index) => (
                    <div key={step.id + '__' + index} style={{ marginBottom: '20px' }}>
                        {stepActive === index && (
                            <div style={{ padding: '10px' }}>
                                <p>{step.content}</p>
                                {/* <div style={{ marginTop: '10px' }}>
                                    <button onClick={prevStep} disabled={index === 0}>
                                        Back
                                    </button>
                                    <button onClick={nextStep} disabled={index === steps.length - 1} style={{ marginLeft: '10px' }}>
                                        Next
                                    </button>
                                </div> */}
                            </div>
                        )}
                    </div>
                ))}
            </Col>
        </Row>
        {/* <div style={{ maxWidth: '400px', margin: 'auto' }}>
            {steps.map((step, index) => (
                <div key={index} style={{ marginBottom: '20px' }}>
                    <div
                        style={{
                            fontWeight: activeStep === index ? 'bold' : 'normal',
                            color: activeStep >= index ? '#000' : '#aaa',
                        }}
                    >
                        {step.label}
                    </div>
                    {activeStep === index && (
                        <div style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                            <p>{step.content}</p>
                            <div style={{ marginTop: '10px' }}>
                                <button onClick={prevStep} disabled={index === 0}>
                                    Back
                                </button>
                                <button onClick={nextStep} disabled={index === steps.length - 1} style={{ marginLeft: '10px' }}>
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            ))}
            {activeStep === steps.length - 1 && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p>🎉 All steps completed!</p>
                    <button onClick={reset}>Reset</button>
                </div>
            )}
        </div> */}

    </>);
};

export default CustomVerticalStepper;